import BaseModelAPI from '../BaseModelAPI';

export default class ApprovalStateList extends BaseModelAPI {

	static entity = 'approvalstatelist'
	static entityName = 'approvalstate';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
